// extracted by mini-css-extract-plugin
export default {"illustrationContainer":"Image_illustrationContainer__Zp8Lf","illustration":"Image_illustration__awNz8","illustrationUpload":"Image_illustrationUpload__UlwRM"};